module.exports = __webpack_public_path__ + "static/media/shape0_1.2443a3ae.obj";